import type { CellContext } from '@tanstack/react-table';

import {
  formatData,
  getColumnsWithTransformedValues,
  transformObjectToCamelCase,
} from '@utilities';

import { getSortType } from '@utilities/components/TableData/utilities/helpers';

import type {
  DashboardFiltersPayload,
  DashboardFiltersResponse,
  DashboardTableCellValue,
  DashboardTablePayload,
  DashboardTableResponse,
  DashboardTableRow,
} from '../types';

export const transformFilters = (data: DashboardFiltersPayload): DashboardFiltersResponse => {
  const response = transformObjectToCamelCase(data) as DashboardFiltersResponse;
  const filters = response.filters.map((filter) => {
    return {
      ...filter,
      isMulti: filter.isMulti ?? false,
      resetDefaults: filter.resetDefaults ?? false,
      rowNumber: filter.rowNumber || 1,
    };
  });

  return { ...response, filters };
};

export const transformTableData = (data: DashboardTablePayload): DashboardTableResponse => {
  const transformedData = transformObjectToCamelCase(data.data) as DashboardTableRow[];
  const columns = getColumnsWithTransformedValues(data.columns).map((column) => {
    const accessor = column.accessor ?? '';

    return {
      accessorKey: accessor,
      cell: ({ getValue }: CellContext<DashboardTableRow, DashboardTableCellValue>) => (
        <span>
          {formatData({
            format: column?.format,
            value: getValue() ?? 'NAN_SENTINEL',
          })}
        </span>
      ),
      enableSorting: true as const,
      format: column.format,
      header: column.Header,
      id: accessor,
      sortDescFirst: false as const,
      sortingFn: getSortType(column.format ?? ''),
    };
  });
  return { columns, data: transformedData };
};
